import React from "react";
import {Box, BoxProps, SxProps} from "@mui/material";
import {scale} from "../../utils";
import {styled} from "@mui/system";

interface Props extends BoxProps {
  children?: React.ReactNode;
  style?: React.CSSProperties;
  sx?: SxProps;
}


const Wrapper = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  height: scale(560),
  width: scale(900),
  backgroundColor: 'white',
  alignItems: 'center',
  justifyContent: 'flex-start',
  borderRadius: scale(20),
  [theme.breakpoints.down('sm')]: {
    width: '100vw',
    height: scale(1100),
    boxSizing: 'border-box',
    borderRadius: scale(0),
  },
}));

const Base = ({children, style, sx}: Props) => {
  return (
    <Wrapper style={{...style}} sx={sx}>
      {children}
    </Wrapper>
  )
}

export default Base
